<app-modal-title
  [title]="'messages.choosePeriodicPattern' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
>
</app-modal-title>

<div
  class="tw-px-2 tw-py-4 tw-flex lg:tw-flex-row tw-flex-col tw-max-w-[1000px]"
  mat-dialog-content
>
  <!-- title -->

  <div class="lg:tw-w-5/12 w-full tw-flex tw-flex-col tw-p-4">
    <p
      class="tw-mt-4 tw-mb-5 tw-text-lg tw-font-normal tw-text-gray-600 dark:tw-text-gray-300"
    >
      {{ "messages.periodicPatterns" | translate }}
      <b>
        {{ "messages.changePeriodicPatterns" | translate }}
      </b>
    </p>
    <div class="tw-flex-center tw-flex-wrap pb-4">
      @for(item of data.periodicPatternsEnumValues; track $index){
      <selector-card
        class="tw-mx-2 tw-my-2.5"
        sizeClass="md:tw-h-[65px] tw-h-[60px] tw-min-w-[176px] lg:tw-min-w-[160px] tw-text-lg tw-font-medium "
        (click)="onSelectPeriodicPattern(item.key)"
        [tickSize]="'md'"
        [tickPosition]="'top'"
        [isReadonly]="data.isReadonly"
        [active]="data.periodicPattern == item.key ? true : false"
      >
        <span class="md:text-lg sm:text-base text-sm" [innerHTML]="item.value">
        </span>
      </selector-card>
      }
    </div>

    <div class="pt-4 px-6 tw-flex-center"
    *ngIf="!data.isReadonly">
      <!--! unSelect All -->
      <button
        (click)="onSelectAll(false)"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        {{ "common.removeAll" | translate }}
        <i class="mdi mdi-trash-can-outline mdi-20px tw-p-0 text-gray-500"></i>
      </button>
      <!--* Select All -->
      <button
        (click)="onSelectAll(true)"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        {{ "common.selectAll" | translate }}
        <i class="mdi mdi-check-all mdi-20px tw-p-0 text-gray-500"></i>
      </button>
    </div>
  </div>

  <!-- calendar -->
  <div class="lg:tw-w-7/12 w-full tw-p-4">
    <app-calender
      [getCalenderDataFromServer]="false"
      [items]="data?.calenderItems"
      [daySelectable]="
        data.periodicPattern == SmartSmsRequestPeriodicPatterns.Custom && !data.isReadonly
      "
    ></app-calender>
    <!-- (dayInfo)="selectedDayInfo = $event"
    [isGetCalender]="isGetCalender"
    (calenderLoading)="calenderLoading($event)"
    (isGetCalender)="isGetCalender = $event" -->
  </div>
</div>
